import { HashLink } from 'react-router-hash-link';


function CustomerBehavior() {
  return (
    <div className="bg-projects2 absolute top-0 left-0 min-h-screen w-full bg-gray-100 flex flex-col items-center justify-start px-4 sm:px-8 scroll-mt-[80px] -mt-[80px]">
      
      <div className="w-full max-w-4xl mx-auto pt-2">
        <HashLink
            smooth
            to="/#resume-prof-projects"
            className="inline-flex items-center text-sm font-semibold text-gray-800 border border-blue-200 px-3 py-2 rounded-lg hover:bg-blue-50 hover:border-blue-400 hover:shadow-sm transition-all"
        >
            <span className="mr-1">←</span> Go back to Home
        </HashLink>
      </div>

      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-6 sm:p-10 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-bold title-color">Customer Behavior Analysis</h1>
        <p className="text-md text-gray-500 italic">Client: Top-tier global bank | Duration: May 2025 – Jul 2025</p>

        <section>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Overview</h2>
          <p className="text-gray-700 mb-2">
            Led an end-to-end proof-of-concept initiative to analyze customer survival patterns using Customer Risk Ratings (CRRs), aimed at predicting likelihood of default versus non-default behavior. The objective was to segment customer profiles and predict survival patterns, enabling segregation of good customers from a large pool of risky ones for tailored decisions & laying the groundwork for a long-term data-driven strategy in customer lifecycle understanding.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li><strong>Role:</strong> Data Scientist</li>
            <li>Validated clustering suitability using Hopkins Statistic (0.92) to confirm spatial cluster tendency in CRR data.</li>
            <li>Guided raw data ingestion efforts for consistency across site-specific platforms.</li>
            <li>Developed segmentation models using KMeans, improving silhouette score by 23% through feature engineering and normalization.</li>
            <li>Applied PCA for dimensionality reduction while retaining 87% variance.</li>
            <li>Built and fine-tuned a Logistic Regression model achieving F1-score: 0.94, AUC-ROC: 0.91, Precision: 93%, Recall: 92%, Specificity: 91%.</li>
            <li>Validated outcomes using Kaplan-Meier analysis on unseen data to verify risk group separation.</li>
            <li>Delivered stakeholder-facing presentations with interpretable cluster maps and business recommendations.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Key Responsibilities</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              <strong>Validated Analytical Feasibility:</strong> Established proof of value for customer behavior modeling using CRR data, securing interest for scaling into a full-fledged data product.
            </li>
            <li>
              <strong>Data-Driven Risk Insights:</strong> Enabled identification of high-risk customer groups through clustering and classification, supporting early intervention strategies.
            </li>
            <li>
              <strong>Foundation for AI-Enhanced Querying:</strong> Initiated roadmap for combining graph intelligence and LLMs to democratize access to customer risk analytics.
            </li>
          </ul>
        </section>

      </div>
    </div>
  );
}

export default CustomerBehavior;
